import { User } from 'api/models';
import { UserStatus } from 'types/types';
import * as yup from 'yup';

export const getUserValidationSchema = (t: (key: string) => string) => {
  return yup.object({
    userId: yup.string(),
    address: yup.string(),
    email: yup
      .string()
      .email(t('general.errors.invalidEmail') ?? '')
      .required(t('general.errors.mandatoryField') ?? ''),
    firstName: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    lastName: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    phone: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    status: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    roles: yup.array().required(t('general.errors.mandatoryField') ?? ''),
  });
};

const initialValues = {
  userId: '',
  address: '',
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  status: UserStatus.pending,
  roles: [],
  subProjectId: '',
  isSystemAdmin: false,
};

export const getUserInitialValues = (user: User | undefined) => {
  return user
    ? {
        userId: user.userId ?? '',
        address: user.address ?? '',
        email: user.email ?? '',
        firstName: user.firstName ?? '',
        lastName: user.lastName ?? '',
        phone: user.phone ?? '',
        status: user.status,
        roles: user.roles ?? [],
        subProjectId: user.subProjects?.[0].id ?? '',
        isSystemAdmin: user.isSystemAdmin ?? false,
      }
    : initialValues;
};
